module.exports = __webpack_public_path__ + "img/not-allow-video.d316e675.svg";